import { FC } from "react"
import classes from "./styles.module.scss"
import { classNames } from "@/shared/lib/helpers/classNames"
import { useTheme } from "@/entities/theme"

interface ButtonProps {
	children: React.ReactNode
	leftSection?: React.ReactNode
	rightSection?: React.ReactNode
	variant?: "primary" | "secondary" | "outline" | "minimal" | "icon"
	size?: "sm" | "md" | "lg"
	extraClasses?: string[]
	onClick?: () => void
}

export const Button: FC<ButtonProps> = ({
	children,
	leftSection,
	rightSection,
	variant = "primary",
	extraClasses,
	onClick,
}) => {
	const { colors } = useTheme()

	const cssVariables: Record<string, string> = {
		"--bg-color-primary": colors.dark[0],
		"--bg-color-secondary": colors.gray[0],
		"--text-color-primary": colors.white[0],
	}

	return (
		<button
			className={classNames([classes.button, classes[variant], ...(extraClasses ?? [])])}
			style={cssVariables}
			onClick={onClick}
		>
			{leftSection && (
				<div className={classNames([classes.leftSection, classes.section])}>{leftSection}</div>
			)}
			<div className={classNames([classes.content, classes.section])}>{children}</div>
			{rightSection && (
				<div className={classNames([classes.rightSection, classes.section])}>{rightSection}</div>
			)}
		</button>
	)
}
